var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-list',_vm._l((_vm.data),function(file,index){return _c('vs-list-item',{key:index,attrs:{"title":file.name}},[_c('action-icon',{staticClass:"text-danger",attrs:{"icon":"DownloadIcon","tooltip":_vm.$t('download')},on:{"click":function($event){return _vm.download(file)}}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }